import "./Loading.css"

const Loading = () => {
    return (
        <div id="waitProc" className="ring" >Pesquisando
            <span id="waitSpan"></span>
        </div>
    )
}
export default Loading